import { UiModule } from '@shared/ui';

import { Component, Input } from '@angular/core';

import { AttachmentComponent } from '../attachment/attachments.component';

@Component({
  selector: 'phoenix-message-attachment',
  imports: [UiModule, AttachmentComponent],
  template: `
    @for (attachment of attachments; track attachment) {
      <div class="w-full">
        <phoenix-attachment
          class="w-full"
          [attachment]="attachment"
          [heightLimit]="heightLimit"
        ></phoenix-attachment>
      </div>
    }
  `,
})
export class MessageAttachmentComponent {
  @Input() attachments: any[] = [];
  @Input() heightLimit = true;
}
